import { render } from "./associateDataModel.vue?vue&type=template&id=5d5fdd37&scoped=true"
import script from "./associateDataModel.vue?vue&type=script&lang=js"
export * from "./associateDataModel.vue?vue&type=script&lang=js"

import "./associateDataModel.vue?vue&type=style&index=0&id=5d5fdd37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5fdd37"]])

export default __exports__